import React from 'react';
import { Navbar } from 'react-bootstrap';
import ExitToApp from '@material-ui/icons/ExitToApp';
import { X_API_KEY } from '../../utils/authentication';
import { Help } from '@material-ui/icons';

export default class Header extends React.Component {

    constructor() {
        super();

        this.state = {
            apiKey: localStorage.getItem(X_API_KEY)
        }

        this.navItemHandleClick = this.navItemHandleClick.bind(this);
        this.onChangeApiKey = this.onChangeApiKey.bind(this);
    }

    navItemHandleClick(eventKey, event) {

        localStorage.setItem(X_API_KEY, this.state.apiKey);
        window.location.reload();

        // if (eventKey === '1') {
        //     this.props.history.push('/options');
        //     this.props.history.go('/options');
        // }
    }

    onHelp() {

        let url = `${window.location.origin}/docu/index.html`;
        if (process.env.NODE_ENV !== 'production') {
            url = `http://dev.tuner4tronic.com/docu/index.html`;
        }

        var win = window.open(url, '_blank');
        win.focus();
    }

    onChangeApiKey(event) {
        this.setState({ apiKey: event.target.value });
    }

    render() {

        let apiKey = localStorage.getItem(X_API_KEY);
        if (apiKey && apiKey.length > 0) {
            apiKey = "*****" + apiKey.substring(apiKey.length - (apiKey.length > 3 ? 3 : 1));
        } else {
            apiKey = 'PUBLIC';
        }
        const user = { email: "user", apiKey: apiKey };

        return (
            <Navbar bg="light" className="navbar-header" onSelect={this.navItemHandleClick}>
                <Navbar.Brand href="#" style={{ display: "flex" }}>
                    <img
                        alt=""
                        src="./images/INV_Logo.png"
                        width="294"
                        height="40"
                        className="d-inline-block"
                    />
                </Navbar.Brand>

                <Navbar.Toggle />
                {/* <Navbar.Collapse className="justify-content-center">
                    <Form inline>
                        <FormControl type="text" placeholder="Search" className="mr-sm-2" />
                        <Button variant="outline-primary">Search</Button>
                    </Form>
                </Navbar.Collapse> */}
                <Navbar.Collapse className="justify-content-end">
                    {/* <NavDropdown title={<FontAwesomeIcon icon={faUser} size='2x' color='#E95B0D' />} drop="left">
                        <div className="headerDropdown">
                            API Key: &emsp;
                            <input
                                name="apiKey"
                                type="password"
                                value={this.state.apiKey ? this.state.apiKey : ''}
                                onChange={this.onChangeApiKey} />
                        </div>
                        <NavDropdown.Divider className="headerDropdownDivider" />
                        <NavDropdown.Item className="headerDropdownItem" eventKey={1}>Change</NavDropdown.Item>
                    </NavDropdown> */}

                    {/* <NavDropdown.Divider />
                    <NavDropdown.Item eventKey={2}>
                        <Link to={`/logout`}>Logout</Link>
                    </NavDropdown.Item> */}
                    <Navbar.Text>
                        <Help className="helpIcon" style={{marginRight: '25px', marginBottom: '2px'}} onClick={this.onHelp} />
                        Signed in as: {user.apiKey} &emsp;
                        <ExitToApp className="logoutIcon" onClick={this.props.handleOpenLogoutPopup} />
                    </Navbar.Text>
                </Navbar.Collapse>
            </Navbar>
        );
    }
};